import { ChevronRight } from "lucide-react";
import { cn } from "../lib/utils";
import { useNavigate, useLocation } from "react-router-dom";

const websiteTabs = [
  {
    id: "template-section",
    label: "Template Section",
    path: "/website/templatesection",
  },
  {
    id: "section-settings",
    label: "Section Settings",
    path: "/website/storesetting",
  },
  { id: "front-theme", label: "Front Theme", path: "/website/fronttheme" },
  { id: "hero-section", label: "Hero Section", path: "/website/herosection" },
  {
    id: "about-section",
    label: "About Section",
    path: "/website/aboutsection",
  },
  {
    id: "testimonials-section",
    label: "Testimonials Section",
    path: "/website/testimonialsection",
  },
  {
    id: "gallery-section",
    label: "Gallery Section",
    path: "/website/gallerysection",
  },
  {
    id: "footer-settings",
    label: "Footer Settings",
    path: "/website/footersection",
  },
  { id: "about-us-page", label: "About Us Page", path: "/website/aboutuspage" },
  {
    id: "cancel-policy",
    label: "Cancel Policy",
    path: "/website/cancelpolicy",
  },
  {
    id: "privacy-policy",
    label: "Privacy & Policy",
    path: "/website/privacypolicy",
  },
  {
    id: "terms-conditions",
    label: "Terms & Conditions",
    path: "/website/termsconditions",
  },
];

export default function WebsiteSubSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="relative w-full layout:w-56 layout:ml-2 layout:mt-3">
      <div className="flex flex-row layout:flex-col overflow-x-auto layout:overflow-y-auto w-full bg-white py-2 layout:py-4 border-b layout:border-none scrollbar-hide relative">
        {websiteTabs.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={cn(
                "relative flex items-center px-4 py-2 text-[14px] layout:text-[15px] font-medium text-left transition-all duration-200 group whitespace-nowrap",
                isActive
                  ? "text-purple-600"
                  : "text-gray-800 hover:text-purple-600"
              )}
            >
              <ChevronRight
                className={cn(
                  "absolute left-0 w-4 h-4 opacity-0 transform transition-all duration-200 hidden layout:block",
                  isActive
                    ? "opacity-100 text-purple-600 translate-x-0"
                    : "group-hover:opacity-100 group-hover:text-purple-600 group-hover:translate-x-0"
                )}
              />
              <span
                className={cn(
                  "transition-all duration-200",
                  isActive ? "layout:translate-x-4" : "layout:group-hover:translate-x-4",
                  isActive && "border-b-2 border-purple-600 layout:border-none pb-1 layout:pb-0"
                )}
              >
                {item.label}
              </span>
            </button>
          );
        })}
        {/* Right side fade for horizontal scroll when tabs visible (below 1030px) */}
        <div className="layout:hidden absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </div>
  );
}
